import { bowserIEName } from 'common-constants/bowser'

export const isIeBrowser = (browserName: string): boolean =>
  browserName === bowserIEName
